import React from 'react';
import { Navigate } from 'react-router-dom';

const UserRoute = ({ element, allowedRoles }) => {
  const userRole = localStorage.getItem("userRole"); // Get the role from localStorage

  // If the user's role is not in the allowedRoles list, redirect to the permission error page
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/permission-error" replace />;
  }

  return element;
};

export default UserRoute;
// No API URLs in this file, so no changes needed.
